











































import { Component, Vue } from "vue-property-decorator";
import SendDetailed from './Detailed.vue'
import Distribution from './Distribution.vue'


@Component({
  components: {
    "send-detailed" :SendDetailed,
    Distribution
  },
})
export default class Detailed extends Vue {
  showTabs:string =  'SendDetailed'
  handShowTabs(val:string){
    this.showTabs = val
  }
}
